import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FactorType, AuthTransaction } from './login.models';
import {
  LOGIN_FEATURE_KEY,
  LoginState,
  LoginPartialState,
} from './login.reducer';

export const getLoginState =
  createFeatureSelector<LoginState>(LOGIN_FEATURE_KEY);

export const transaction = createSelector(
  getLoginState,
  (state) => state.transaction,
);

export const getFactorByType = createSelector(
  transaction,
  (t: AuthTransaction | undefined, props: { factorType: FactorType }) =>
    t?.factors?.find((factor) => factor.factorType === props.factorType),
);

export const signInError = createSelector(
  getLoginState,
  (state) => state.signInError,
);

export const isTransactionInProgress = createSelector(
  getLoginState,
  (state) => state.isTransactionInProgress,
);

export const newPhoneNumber = createSelector(
  getLoginState,
  (state) => state.newPhoneNumber,
);

export const registrationPhoneNumber = createSelector(
  getLoginState,
  (state) => state.registrationPhoneNumber,
);

export const canGoBack = createSelector(
  getLoginState,
  (state) => !!state.canGoBack,
);

export const hasTransaction = createSelector(
  getLoginState,
  (state) => state.hasTransaction,
);

export const hasBeenSignedIn = createSelector(
  getLoginState,
  (state) => state.hasBeenSignedIn,
);

export const isANewUser = createSelector(
  getLoginState,
  (state) => state.isANewUser,
);

export const getFactorVerification = createSelector(
  getLoginState,
  (state) => state.factorVerification,
);

export const shouldSkipMfaWelcomeScreen = createSelector(
  getLoginState,
  (state) => state.shouldSkipMfaWelcomeScreen,
);

export const hasValidCredentials = createSelector(
  getLoginState,
  (state) => state.hasValidCredentials,
);

export const isAfterRegistration = createSelector(
  getLoginState,
  (state) => state.isAfterRegistration,
);
